import { sortBy } from "lodash";
import API from "serviceshift-ui/api-client";

export default {
  fetchWarrantyPrograms({ commit }, activeOnly = false) {
    return API.warrantyProgram.getAll(activeOnly).then((res) => {
      // TODO: API currently sends back warranty programs in a somewhat random
      // sorting order. This patches it so we sort by most recently created.
      const programs = sortBy(res.data || [], (data) => data.id).reverse();
      commit("replace", {
        state: "warrantyPrograms",
        data: programs
      });
    });
  },
  fetchWarrantyProgram({ commit }, id) {
    return API.warrantyProgram.get(id).then((res) => {
      commit("replace", {
        state: "currentWarrantyProgram",
        data: res.data
      });
    });
  },
  clearCurrentWarrantyProgram({ commit }) {
    commit("replace", {
      state: "currentWarrantyProgram",
      data: null
    });
  }
};
